import { useEffect, useState } from "react";

export default function useHasFinePointer() {
  const [hasFinePointer, setHasFinePointer] = useState(
    () => window.matchMedia?.("(any-pointer: fine)")?.matches ?? true
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(any-pointer: fine)");
    const handleChange = (e) => setHasFinePointer(e.matches);

    mediaQuery.addEventListener?.("change", handleChange);
    return () => mediaQuery.removeEventListener?.("change", handleChange);
  }, []);

  return hasFinePointer;
}
